import { Signal, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, Subject, switchMap, takeWhile, timer } from 'rxjs';

/** How long "Resend" stays off after a code went out. */
const RESEND_COOLDOWN_S = 60;

export interface ResendCooldown {
  /** Seconds until "Resend" is offered again; 0 offers it. */
  readonly remaining: Signal<number>;
  /** (Re)starts the countdown; call it whenever a code went out. */
  start(): void;
}

/**
 * The countdown behind `app-code-resend`'s "resend in 42 s". Create it in
 * an injection context (a field initializer): it stops with the component.
 */
export function resendCooldown(): ResendCooldown {
  const remaining = signal(0);
  const starts = new Subject<void>();
  starts
    .pipe(
      // each start replaces the running countdown
      switchMap(() =>
        timer(0, 1000).pipe(
          map(tick => RESEND_COOLDOWN_S - tick),
          takeWhile(left => left >= 0)
        )
      ),
      takeUntilDestroyed()
    )
    .subscribe(left => remaining.set(left));
  return { remaining: remaining.asReadonly(), start: () => starts.next() };
}
